import { IonButton, IonIcon, IonItem, IonLabel } from "@ionic/react";
import axios from "axios";
import { addOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Template } from "../../../@types/template";
import { TemplateQuestion } from "../../../@types/templateQuestion";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const UserTemplateItem = ({ template }: { template: Template }) => {
  const { id }: { id: string } = useParams();
  const [questionsTemplates, setQuestionTemplates] = useState<TemplateQuestion[]>([]);

  const questions = async () => {
    const { data } = await axiosInstance.get(`${api.baseURL}formquestion`, {
      params: {
        populate: false,
        where: {
          form: template.id,
        },
      },
    })
    setQuestionTemplates(data);
  }

  useEffect(() => {
    questions();
  }, []);

  return (
    <IonItem>
      <IonLabel>
        <h2 style={{ fontWeight: 500 }}>{template.name}</h2>
        <h4>Archivos: {questionsTemplates.length}</h4>
        <h4>Plantillas automáticas: {questionsTemplates.filter((question) => question.template !== null).length}</h4>
      </IonLabel>
      <IonButton routerLink={`/app/rrhh/usuarios/acuerdos/${id}/asociar/${template.id}`} size="default">
        <IonIcon icon={addOutline} />
      </IonButton>
    </IonItem>
  );
};
